import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from '@angular/core';
import { API_CMS_ENDPOINT, API_ENDPOINT, BRAND } from '../core/DI';
import { ParamMap } from "@angular/router";
import { CategoryFiltersRequestDto, SingleGenericStringValueIdCategoryFilter } from "app/core/models/filter-backend";
import { GenericCardAndFiltersDtoResponse } from "app/core/models/generic-card-and-filter.dto-response";
import { GenericSummaryCardDtoResponse } from "app/core/models/generic-summary-card.dto-response";
import { KitComponentsDtoResponse } from "app/core/models/kit-components.dto-response";
import { MakeYearModel } from "app/core/models/make-year-model.model";
import { PlacardToolKitsDtoResponse, PlacardToolKitVehiclesDtoResponse, PlacardToolPSIsDtoResponse } from "app/core/models/placard-tool.dto-response";
import { ProductCategoryFilter } from "app/core/models/product-category-filter.model";
import { ProductDetailsDtoResponse } from "app/core/models/product-details.dto-response";
import { ProductSpecsOptions } from "app/core/models/product-specs-options.model";
import { Product } from "app/core/models/product.model";
import { StaggeredProductDetailsDtoResponse } from "app/core/models/staggered-product-details.dto-response";
import { Observable, Subject } from "rxjs";
import { Helper } from "./helper";
import { IProductService } from "./iproduct.service";
//import { PackageKitsDtoResponse } from "app/core/models/packagekits-dto";
import { LastSubject } from "app/core/LastSubject";
import { Constants, HTTPStatusCode } from '../core/Constants';
import { KitPackage } from "app/core/models/kit-package";
import { StaggeredPackageBuilderModel } from "app/core/models/staggered-package-builder.model";
import { PackageBuilderModel } from "app/core/models/package-builder.model";
import { CustomerFeedbackOption } from "app/core/models/customer-feedback-option";

@Injectable()
export class PackageKitService implements IProductService {
  private productsSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
  //private packageKitsSubject = new LastSubject<PackageKitsDtoResponse>();
  private searchWithFilterInProgress = new Subject<boolean>();
  private lastStaggerType: string = null;
  private lastShowList: string = null;
  private componentsSubject = new LastSubject<KitComponentsDtoResponse>();

  constructor(
    @Inject(API_ENDPOINT) private apiEndpoint: string,
    @Inject(API_CMS_ENDPOINT) private apiCmsEndpoint: string,
    private http: HttpClient) { }
    
  get onProducts(): Observable<GenericCardAndFiltersDtoResponse> {
    return this.productsSubject.asObservable();
  }
  get onComponents(): Observable<KitComponentsDtoResponse> {
    return this.componentsSubject.asObservable();
  }
  get onSearchWithFilter(): Observable<boolean> {
    return this.searchWithFilterInProgress.asObservable();
  }
  //get onPackageKits(): Observable<PackageKitsDtoResponse> {
  //  return this.packageKitsSubject.asObservable();
  //}

  getProductDetailsBySpecs(productId: string): Observable<ProductDetailsDtoResponse> {
    const api = `${this.apiEndpoint}/items/details?id=${encodeURIComponent(productId)}`;
    return this.http.get<ProductDetailsDtoResponse>(api);
  }
  getProductDetails(productId: string, carDetails: MakeYearModel, frontWheelOrTireId: string, rearWheelOrTireId: string): Observable<ProductDetailsDtoResponse> {
    throw new Error("Method not implemented.");
  }
  getStaggeredProductDetails(productId: string, carDetails: MakeYearModel, frontWheelOrTireId: string, rearWheelOrTireId: string): Observable<StaggeredProductDetailsDtoResponse> {
    throw new Error("Method not implemented.");
  }
  getStaggeredProductDetailsBySpecs(productId: string): Observable<StaggeredProductDetailsDtoResponse> {
    throw new Error("Method not implemented.");
  }
  postProductToCart(id: string, qty: number, warningNotes: string[], pairNo: string, productType: string, productStyle: string) {
    throw new Error("Method not implemented.");
  }
  postProductPairToCart(frontId: string, frontQty: number, frontWarningNotes: string[], rearId: string, rearQty: number, rearWarningNotes: string[], pairNo: string, productType: string) {
    throw new Error("Method not implemented.");
  }
  postProductsToCart(frontProduct: Product, rearProduct: Product, frontLabours: Product[], rearLabours: Product[], car: MakeYearModel) {
    throw new Error("Method not implemented.");
  }
  postKitToCart(id: string, qty: number) {

    this.searchComponents(id);

    this.onComponents.subscribe(
      responseProduct => {
        if (responseProduct != null) {
          const api = `${this.apiCmsEndpoint}/cart/AddKit`;
          const kitPackage: KitPackage = new KitPackage();

          kitPackage.kitID = id;
          kitPackage.kit = this.createProduct(id, qty, Constants.PRODUCT_TYPE_KIT, null, "", 1);
          kitPackage.package = new StaggeredPackageBuilderModel();
          kitPackage.package.front = new PackageBuilderModel();
          kitPackage.package.rear = new PackageBuilderModel();

          for (let num = 0; num < responseProduct.cards.length; num++) {
            if (responseProduct.cards[num].id != null) {

              switch (responseProduct.cards[num].itemCategoryId) {
                case 1://Accessories
                  kitPackage.package.front.hardwares.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_HARDWARE, null, "", num + 2));
                  break;
                case 2://Wheels
                  kitPackage.package.front.wheel = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_WHEEL, null, "", num + 2);
                  break;
                case 3://Tires
                  kitPackage.package.front.tire = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_TIRE, null, "", num + 2);
                  break;
                case 4://Kits
                case 5://Services
                case 6://Other
                  continue;
                case 7://Consumables
                  kitPackage.package.front.labours.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_LABOUR, null, "", num + 2));
                  break;
                default:
                  break;
              }
            }
          }

          this.http.post(api, kitPackage).toPromise().then(response => {
            window.location.href = Constants.SHOPPING_CART_HREF;
          }).catch((err: any) => {
            window.location.href = Constants.SHOPPING_CART_HREF;
          });

        }
      }, Helper.handleError);


  }

  createProduct(id: string, qty: number, productType: string, warningNotes: string[], pairNo: string, sequence: number): Product {
    return new Product({
      id: id,
      warningNotes: warningNotes,
      quantity: qty,
      type: productType, //Constants.PRODUCT_TYPE_WHEEL,
      pairNo: pairNo,
      sequence: sequence
    });
  }
  postToCartWithCar(frontId: string, frontQty: number, rearId: string, rearQty: number, frontWarningNotes: string[], rearWarningNotes: string[], car: MakeYearModel, pairNo: string) {
    throw new Error("Method not implemented.");
  }
  getProductFilters(): Observable<ProductSpecsOptions[]> {
    throw new Error("Method not implemented.");
  }
  getProductByBrandFilters(): Observable<ProductSpecsOptions[]> {
    throw new Error("Method not implemented.");
  }
  searchWithTextAndFilter(searchText: string, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error("Method not implemented.");
  }
  searchComponents(searchText: string): void {
    const api = `${this.apiEndpoint}/items/kitcomponents/?id=${encodeURIComponent(searchText)}`;

    this.http.get<KitComponentsDtoResponse>(api).subscribe(componentsDto => {

      this.componentsSubject.next(componentsDto);

    }, Helper.handleError);

  }
  getProductDetailsByVehicleAndFilterAndStyleAndFinish(carDetails: MakeYearModel, wheelStagger: string, filters: CategoryFiltersRequestDto): Observable<GenericSummaryCardDtoResponse[]> {
    throw new Error("Method not implemented.");
  }
  getProductsByVehicleAndFilter(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    let stagger: string = null;
    if ((<any>filters).wheelstagger) {
      stagger = (<SingleGenericStringValueIdCategoryFilter>(<any>filters).wheelstagger).value.id;
      if (this.lastStaggerType !== stagger) {
        this.lastStaggerType = stagger;
        loadSecondaryFilters = true;
      }
      delete (<any>filters).wheelstagger;
    }
    let showList: string = null;
    if ((<any>filters).show) {
      showList = (<any>filters).show.values.map(v => v.id).join(',');
    }
    if (this.lastShowList !== showList) {
      this.lastShowList = showList;
      loadSecondaryFilters = true;
    }

    this.searchWithFilterInProgress.next(true);
    const api = `${this.apiEndpoint}/items/packagekits`;
    this.http.post<GenericCardAndFiltersDtoResponse>(api, {
      baseFilter: searchParams,
      secondaryFilter: filters,
      loadSecondaryFilters: loadSecondaryFilters,
      stagger: stagger,
    }, { observe: 'response', responseType: 'json' })
      .subscribe(res => {
        let packageKitAndFiltersDto: GenericCardAndFiltersDtoResponse;
        if (res.status === HTTPStatusCode.NO_CONTENT) {
          packageKitAndFiltersDto = {
            categoryfilters: null,
            productSummaryCards: [],
            itemCount: 0,
            sortOptions: [],
            hasMoreThanOneOEMTPMS: false,
            boltsNutsInfos: null,
            styleFinish: [],
            micrositeItemCounts: [],
            alternateHexSizeExists: false
          };
        } else {
          packageKitAndFiltersDto = res.body;
        }
        this.productsSubject.next(packageKitAndFiltersDto);
        this.searchWithFilterInProgress.next(false);
      },
        Helper.handleError);
  }
  getProductsByVehicleAndFilterForWheel(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean, frontWheelId: string, rearWheelId: string, frontWheelQty: number, rearWheelQty: number, frontOffset?: number, rearOffset?: number): void {
    throw new Error("Method not implemented.");
  }
  getProductsByVehicleAndFilterForTire(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean, frontTireId: string, rearTireId: string, frontTireQty: number, rearTireQty: number): void {
    throw new Error('NotSupportedException');
  }
  getProductsByVehicleAndFilterForAccessory(productCategoryFilter: ProductCategoryFilter, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error("Method not implemented.");
  }
  getProductsBySpecsAndFilter(productCategoryFilter: ProductCategoryFilter, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error("Method not implemented.");
  }
  getCategoryFiltersFromRoute(params: ParamMap): ProductCategoryFilter {
    throw new Error("Method not implemented.");
  }
  getPlacardToolKits(kitNo: string, keyword: string): Observable<PlacardToolKitsDtoResponse> {
    throw new Error("Method not implemented.");
  }
  getPlacardToolKitVehicles(kitNo: string): Observable<PlacardToolKitVehiclesDtoResponse> {
    throw new Error("Method not implemented.");
  }
  getPlacardToolPSIs(vehicleOptionID: number, tire: string, rearRire: string): Observable<PlacardToolPSIsDtoResponse> {
    throw new Error("Method not implemented.");
  }

  //getPackageKitsByVehicle(searchParams: MakeYearModel) {
  //  this.searchWithFilterInProgress.next(true);

  //  const api = `${this.apiEndpoint}/items/packagekits/` +
  //    `makes/${Helper.encodeURIComponent2(searchParams.make)}/` +
  //    `years/${Helper.encodeURIComponent2(searchParams.getYearStr)}/` +
  //    `models/${Helper.encodeURIComponent2(searchParams.model)}/` +
  //    `submodels/${Helper.encodeURIComponent2(searchParams.submodel)}/` +
  //    `options/${Helper.encodeURIComponent2(searchParams.option)}`;
  //  return this.http.get<PackageKitsDtoResponse>(api).subscribe(pcgKits => {
  //    this.packageKitsSubject.next(pcgKits);
  //    this.searchWithFilterInProgress.next(false);

  //  }, Helper.handleError);
  //}
    customParameter?: {};

    submitCustomerFeedback(params: ParamMap, comments: string, categoryId: number, departmentResponsible: string, itmeNo: string, customerFeedbackOptionId: string) {
    throw new Error("Method not implemented.");
  }
    getCustomerFeedbackOptions(): Observable<CustomerFeedbackOption[]> {
        const api = `${this.apiCmsEndpoint}/angular/customerfeedbackoption`;

        return this.http.get<CustomerFeedbackOption[]>(api);
    }
}
